// statsActions.js

import { createAsyncThunk, current } from "@reduxjs/toolkit"
import { axiosGet } from "../../utilities/axiosRequest"
import {
    monthlyPerformanceReportURL,
    monthlyPerformanceReportForOrgURL,
    monthlyPerformanceReportForOrgClinicURL,
    patientsOverviewURL,
    performanceReportGraphURL,
    engagementBreakupGraphURL,
    consentBreakupGraphURL,
    getDashboardStatsURL,
} from "../../apiEndPoints"
import {
    updateClinicsList,
    updateOrganisationList,
    updateClinicsLevelList,
    updatePatientsOverview,
} from "./statsSlice"
import { logTransaction } from "../appActions"
import moment from "moment"

export const getMonthlyPerformanceReport = createAsyncThunk(
    "stats/getMonthlyPerformanceReport",
    async ({ month, year }, { dispatch }) => {
        try {
            const url = `${monthlyPerformanceReportURL}?month=${month}&year=${year}`
            const response = await axiosGet(url)
            dispatch(updateOrganisationList(response.data.responseData)) // Adjust here to get the responseData directly
        } catch (error) {
            throw error
        }
    }
)

export const getMonthlyPerformanceReportForOrg = createAsyncThunk(
    "stats/getMonthlyPerformanceReportForOrg",
    async ({ month, year, orgId }, { dispatch }) => {
        try {
            const url = `${monthlyPerformanceReportForOrgURL}?month=${month}&year=${year}&organizationId=${orgId}`
            const response = await axiosGet(url)

            dispatch(updateClinicsLevelList(response?.data?.responseData || [])) // Adjust here to get the responseData directly
        } catch (error) {
            throw error
        }
    }
)

export const getMonthlyPerformanceReportForClinic = createAsyncThunk(
    "stats/getMonthlyPerformanceReportForClinic",
    async ({ month, year, clinicId }, { dispatch }) => {
        try {
            const url = `${monthlyPerformanceReportForOrgClinicURL}?month=${month}&year=${year}&clinicId=${clinicId}`
            const response = await axiosGet(url)

            dispatch(updateClinicsList(response.data.responseData)) // Adjust here to get the responseData directly
        } catch (error) {
            throw error
        }
    }
)

export const getPatientsOverview = createAsyncThunk(
    "stats/getPatientsOverview",
    async ({ startDate, endDate }, { dispatch }) => {
        try {
            const url = `${patientsOverviewURL}?startDate=${startDate}&endDate=${endDate}`
            const response = await axiosGet(url)

            dispatch(updatePatientsOverview(response.data.responseData)) // Adjust here to get the responseData directly
        } catch (error) {
            throw error
        }
    }
)

export function getPerformanceReport(filter, success, failure) {
    return function (dispatch, getState) {
        const userId = getState().login.userProfile?.userId
        const url =
            performanceReportGraphURL + `?filterType=${filter}&userId=${userId}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Fetch performance report success",
                            response
                        )
                    )
                } else {
                    failure()
                }
            })
            .catch(err => {
                failure(err)
                dispatch(
                    logTransaction("Fetch performance report Failure", err)
                )
            })
    }
}

export function getEngagementReport(filter, success, failure) {
    return function (dispatch, getState) {
        const userId = getState().login.userProfile?.userId
        const url =
            engagementBreakupGraphURL + `?filterType=${filter}&userId=${userId}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Fetch engagement report success",
                            response
                        )
                    )
                } else {
                    failure()
                }
            })
            .catch(err => {
                failure(err)
                dispatch(logTransaction("Fetch engagement report failure", err))
            })
    }
}

export function getConsentReport(filter, success, failure) {
    return function (dispatch, getState) {
        const userId = getState().login.userProfile?.userId
        const url =
            consentBreakupGraphURL + `?filterType=${filter}&userId=${userId}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction("Fetch consent report success", response)
                    )
                } else {
                    failure()
                }
            })
            .catch(err => {
                failure(err)
                dispatch(
                    logTransaction("Fetch engagement consent failure", err)
                )
            })
    }
}

export function getDashboardStats(clinicId, success, failure) {
    return function (dispatch, getState) {
        const currentMonth = moment().month() + 1
        const currentYear = moment().year()
        const program = getState().user.program
        let url =
            getDashboardStatsURL +
            `?month=${currentMonth}&year=${currentYear}&programId=${program.id}`
        if (clinicId) {
            url += `&clinicId=${clinicId}`
        }
        axiosGet(url)
            .then(response => {
                if (
                    response?.data?.responseData &&
                    response.data.responseData.length > 0
                ) {
                    success(response.data.responseData)
                    dispatch(
                        logTransaction(
                            "Fetch dashboard stats success",
                            response
                        )
                    )
                } else {
                    failure()
                }
            })
            .catch(err => {
                failure(err)
                dispatch(logTransaction("Fetch dashboard stats failure", err))
            })
    }
}
